import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import type { EcoPart } from '@gql-generated/graphql'
import { useSetAtom } from 'jotai'
import { displayEcoTaxesDrawerAtom } from '../../services/product.store'

const ecoTaxesTranslationKey = (totalEcoTaxes: number) => {
  switch (totalEcoTaxes) {
    case 1:
      return 'oneEcoTax'
    case 2:
      return 'twoEcoTaxes'
    default:
      return 'otherEcoTaxes'
  }
}

export type ProductBuyBoxEcoTaxesProps = {
  ecoTaxes: EcoPart
}

export function ProductBuyBoxEcoTaxes({
  ecoTaxes,
}: ProductBuyBoxEcoTaxesProps): React.ReactElement | null {
  const { t, Trans } = useTranslation(['productBuyBox'])
  const setIsDrawerOpen = useSetAtom(displayEcoTaxesDrawerAtom)

  // TODO: Refactor this part when the EcoPart type has been updated.
  const ecoTaxesParts: { name: string; price: number }[] = []

  if (ecoTaxes.deee) {
    ecoTaxesParts.push({ name: t('productBuyBox:ecoTaxes.deee'), price: ecoTaxes.deee })
  }

  if (ecoTaxes.furnishing) {
    ecoTaxesParts.push({ name: t('productBuyBox:ecoTaxes.furnishing'), price: ecoTaxes.furnishing })
  }

  if (ecoTaxes.pmcb) {
    ecoTaxesParts.push({ name: t('productBuyBox:ecoTaxes.pmcb'), price: ecoTaxes.pmcb })
  }

  if (ecoTaxesParts.length === 0) {
    return null
  }

  return (
    <span className="mt-1 inline-block uppercase text-brand-2-900">
      <Trans
        i18nKey={`productBuyBox:ecoTaxes.${ecoTaxesTranslationKey(ecoTaxesParts.length)}`}
        values={{ elements: ecoTaxesParts }}
        components={{
          buttonNode: (
            <button
              type="button"
              className="font-bold underline"
              onClick={(e) => {
                setIsDrawerOpen(true)
                pushToGtmDataLayer({
                  event: 'gaEvent',
                  eventCategory: 'écoparts',
                  eventAction: 'fiche article_produit',
                  eventLabel: e.currentTarget.textContent || '',
                })
              }}
            />
          ),
        }}
      />
    </span>
  )
}
